
import { useState, useEffect } from 'react';
import { auditLogger } from '../services/auditService';
import { AuditStats, AuditEntry } from '../types/audit';

export const useAuditMonitoring = () => {
  const [stats, setStats] = useState<AuditStats | null>(null);
  const [recentEntries, setRecentEntries] = useState<AuditEntry[]>([]);
  const [securityAlerts, setSecurityAlerts] = useState<AuditEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const updateData = () => {
      try {
        const currentStats = auditLogger.getAuditStats();
        const recent = auditLogger.getRecentEntries(50);
        const alerts = auditLogger.getSecurityAlerts(25);

        setStats(currentStats);
        setRecentEntries(recent);
        setSecurityAlerts(alerts);
        setIsLoading(false);
      } catch (error) {
        console.error('Error updating audit data:', error);
        setIsLoading(false);
      }
    };

    // Initial load
    updateData();

    // Update every 30 seconds
    const interval = setInterval(updateData, 30000);

    return () => clearInterval(interval);
  }, []);

  const refreshData = () => {
    setIsLoading(true);
    const currentStats = auditLogger.getAuditStats();
    const recent = auditLogger.getRecentEntries(50);
    const alerts = auditLogger.getSecurityAlerts(25);

    setStats(currentStats);
    setRecentEntries(recent);
    setSecurityAlerts(alerts);
    setIsLoading(false);
  };

  return {
    stats,
    recentEntries,
    securityAlerts,
    isLoading,
    refreshData,
  };
};
